import { observable, action,  decorate } from 'mobx';

class DGRModalStore {
    iframeURL = 'http://www.24hourfitness.com/membership/inclub_privacy_policy.html'
    //observables
    isOpen = false;
    section = 'club_number'
    closeHidden = false 
    //  login_login_email 
    //  register
    //  register_finish

    //setSection
    openModal(){
        this.isOpen = true
    }
    closeModal(){
        this.isOpen = false 
    }
    setURL(url){
        this.iframeURL = url   
    }
    setSection(section){
        this.section = section   
    }
    setCloseHidden(){
        this.closeHidden = true
    }
    setCloseVisible(){
        this.closeHidden = false 
    }
}

decorate(DGRModalStore, {
    closeHidden:  observable,
    openModal: action,
    closeModal: action,
    setSection: action,
    isOpen: observable,
    setCloseHidden: action,
    setCloseVisible: action,
    section: observable
});

export default new DGRModalStore();



// WEBPACK FOOTER //
// ./src/stores/DGRModalStore/index.js